/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ValidateWeekendVisibilityChangeInput = {|
  weekendDisplayPerUser?: ?boolean,
  weekendDisplayShowAlways?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type ValidateWeekendVisibilityChangeMutationVariables = {|
  input: ValidateWeekendVisibilityChangeInput
|};
export type ValidateWeekendVisibilityChangeMutationResponse = {|
  +validateWeekendVisibilityChange: ?{|
    +isCompanyPrevented: ?boolean,
    +isActiveUserPrevented: ?boolean,
    +isInactiveUserPrevented: ?boolean,
  |}
|};
export type ValidateWeekendVisibilityChangeMutation = {|
  variables: ValidateWeekendVisibilityChangeMutationVariables,
  response: ValidateWeekendVisibilityChangeMutationResponse,
|};
*/


/*
mutation ValidateWeekendVisibilityChangeMutation(
  $input: ValidateWeekendVisibilityChangeInput!
) {
  validateWeekendVisibilityChange(input: $input) {
    isCompanyPrevented
    isActiveUserPrevented
    isInactiveUserPrevented
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ValidateWeekendVisibilityChangeInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ValidateWeekendVisibilityChangePayload",
    "kind": "LinkedField",
    "name": "validateWeekendVisibilityChange",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCompanyPrevented",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActiveUserPrevented",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isInactiveUserPrevented",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValidateWeekendVisibilityChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValidateWeekendVisibilityChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ValidateWeekendVisibilityChangeMutation",
    "operationKind": "mutation",
    "text": "mutation ValidateWeekendVisibilityChangeMutation(\n  $input: ValidateWeekendVisibilityChangeInput!\n) {\n  validateWeekendVisibilityChange(input: $input) {\n    isCompanyPrevented\n    isActiveUserPrevented\n    isInactiveUserPrevented\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2c9057dacf2b9b4dfe7a44060ac552c4';

module.exports = node;
